import React from 'react';
import SEO from '../Components/SEO';
import { buildBreadcrumbSchema, PAGE_SEO } from '../seoConfig';

const TermsAndConditions = () => {
    return (
        <>
            <SEO
                title={PAGE_SEO.terms.title}
                description={PAGE_SEO.terms.description}
                path={PAGE_SEO.terms.path}
                noindex={PAGE_SEO.terms.noindex}
                structuredData={buildBreadcrumbSchema([
                    { name: 'Início', path: '/' },
                    { name: 'Termos & Condições', path: '/termos' },
                ])}
            />
            
            <div className="bg-white dark:bg-black min-h-screen pt-40 pb-32 font-sans transition-colors duration-500">
                {/* Minimalist Legal Hero */}
                <div className="max-w-4xl mx-auto px-6 mb-24">
                    <div className="inline-block px-4 py-1 mb-6 text-[10px] font-black uppercase tracking-[0.4em] text-[#cebc52] bg-[#cebc52]/5 border border-[#cebc52]/20 rounded-full">
                        Legal Department
                    </div>
                    <h1 className="text-3xl sm:text-4xl md:text-6xl font-black uppercase tracking-tighter text-gray-900 dark:text-white mb-8">
                        TERMOS & <br/> <span className="text-[#cebc52]">CONDIÇÕES</span>
                    </h1>
                    <div className="w-20 h-1 bg-[#cebc52]"></div>
                    <p className="mt-8 text-gray-400 text-lg font-light max-w-2xl">
                        Ao aceder ao website da Auto João Pires, concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis.
                    </p>
                </div>

                {/* Main Content Pane */}
                <div className="max-w-4xl mx-auto px-6">
                    <div className="space-y-24">
                        
                        {/* Section I: Aceitação */}
                        <section className="relative">
                            <div className="absolute -left-12 top-0 text-6xl font-black text-gray-100 dark:text-white/5 select-none">I</div>
                            <h2 className="text-2xl font-black uppercase tracking-tight text-gray-900 dark:text-white mb-8 flex items-center gap-4">
                                <span className="w-8 h-[2px] bg-[#cebc52]"></span>
                                Aceitação de Termos
                            </h2>
                            
                            <div className="prose prose-sm md:prose-base dark:prose-invert max-w-none text-gray-600 dark:text-gray-400 leading-relaxed space-y-6">
                                <p>
                                    O acesso e uso deste website estão sujeitos aos seguintes termos e condições e a todas as leis aplicáveis. Ao navegar e aceder a este website, o utilizador aceita, sem limitação ou qualificação, estes Termos e Condições.
                                </p>
                                <p>
                                    A Auto João Pires reserva-se o direito de rever estes Termos e Condições a qualquer momento, atualizando esta página. O utilizador deve visitar esta página periodicamente para rever os Termos e Condições atuais.
                                </p>
                            </div>
                        </section>

                        <div className="h-px bg-gray-100 dark:bg-white/5"></div>

                        {/* Section II: Uso do Site */}
                        <section className="relative">
                            <div className="absolute -left-12 top-0 text-6xl font-black text-gray-100 dark:text-white/5 select-none">II</div>
                            <h2 className="text-2xl font-black uppercase tracking-tight text-gray-900 dark:text-white mb-8 flex items-center gap-4">
                                <span className="w-8 h-[2px] bg-[#cebc52]"></span>
                                Licença de Uso
                            </h2>

                            <div className="prose prose-sm md:prose-base dark:prose-invert max-w-none text-gray-600 dark:text-gray-400 leading-relaxed space-y-6">
                                <p>
                                    É concedida permissão para descarregar temporariamente uma cópia dos materiais (informações ou software) no website Auto João Pires, apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título e, sob esta licença, você não pode:
                                </p>
                                <ul className="list-none space-y-4 pl-0">
                                    {[
                                        "Modificar ou copiar os materiais;",
                                        "Usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial);",
                                        "Tentar descompilar ou fazer engenharia reversa de qualquer software contido no website Auto João Pires;",
                                        "Remover quaisquer direitos de autor ou outras notações de propriedade dos materiais;",
                                        "Transferir os materiais para outra pessoa ou 'espelhar' os materiais em qualquer outro servidor."
                                    ].map((item, idx) => (
                                        <li key={idx} className="flex gap-4 items-start">
                                            <div className="w-1.5 h-1.5 rounded-full bg-[#cebc52] mt-2 shrink-0"></div>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </section>

                        <div className="h-px bg-gray-100 dark:bg-white/5"></div>

                        {/* Section III: Isenção de Responsabilidade */}
                        <section className="relative">
                            <div className="absolute -left-12 top-0 text-6xl font-black text-gray-100 dark:text-white/5 select-none">III</div>
                            <h2 className="text-2xl font-black uppercase tracking-tight text-gray-900 dark:text-white mb-8 flex items-center gap-4">
                                <span className="w-8 h-[2px] bg-[#cebc52]"></span>
                                Isenção de Responsabilidade
                            </h2>

                            <div className="prose prose-sm md:prose-base dark:prose-invert max-w-none text-gray-600 dark:text-gray-400 leading-relaxed space-y-6">
                                <p>
                                    Os materiais no website da Auto João Pires são fornecidos 'como estão'. A Auto João Pires não oferece garantias, expressas ou implícitas, e, por este meio, isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um fim específico ou não violação de propriedade intelectual ou outra violação de direitos.
                                </p>
                                <p>
                                    Além disso, a Auto João Pires não garante ou faz qualquer representação relativa à precisão, aos resultados prováveis ​​ou à confiabilidade do uso dos materiais no seu website ou de outra forma relacionado a esses materiais ou em sites vinculados a este site.
                                </p>
                            </div>
                        </section>

                        <div className="h-px bg-gray-100 dark:bg-white/5"></div>

                        {/* Section IV: Limitações */}
                        <section className="relative">
                            <div className="absolute -left-12 top-0 text-6xl font-black text-gray-100 dark:text-white/5 select-none">IV</div>
                            <h2 className="text-2xl font-black uppercase tracking-tight text-gray-900 dark:text-white mb-8 flex items-center gap-4">
                                <span className="w-8 h-[2px] bg-[#cebc52]"></span>
                                Limitações
                            </h2>

                            <div className="prose prose-sm md:prose-base dark:prose-invert max-w-none text-gray-600 dark:text-gray-400 leading-relaxed space-y-6">
                                <p>
                                    Em nenhum caso a Auto João Pires ou seus fornecedores serão responsáveis ​​por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro ou devido a interrupção dos negócios) decorrentes do uso ou da incapacidade de usar os materiais em Auto João Pires, mesmo que a Auto João Pires ou um representante autorizado da Auto João Pires tenha sido notificado oralmente ou por escrito da possibilidade de tais danos.
                                </p>
                            </div>
                        </section>

                        <div className="pt-20 border-t border-gray-100 dark:bg-white/5 text-center">
                            <p className="text-[10px] font-black uppercase tracking-[0.4em] text-gray-400 mb-2">Última Atualização</p>
                            <p className="text-gray-900 dark:text-white font-bold">Maio 2026</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TermsAndConditions;
